export const SET_SELECTED_STATUS_ACTION = 'selectedStatus';
export const SET_SEARCH_TEXT_ACTION = 'searchText';
export const SET_ONLY_ATIVOS_ACTION = 'onlyAtivos';
